import { useMutation, useQueryClient } from '@tanstack/react-query';
import { pnidApi } from '../api';
import { queryKeys } from '../queries/keys';
import type { PnidSetupUpdate } from '../types';

export function useSetPnidSetup(docId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (setup: PnidSetupUpdate) => pnidApi.setPnidSetup(docId, setup),
    onSuccess: (state) => queryClient.setQueryData(queryKeys.pnidState(docId), state),
  });
}
